import iconSizes from "./iconSizes";

export { iconSizes };
